module.exports = __webpack_public_path__ + "../../../static/img/bs_ic_02.48b9a360.png";